import type { TFunction } from "i18next";
import { TaxIncentiveType } from "@/domain/classification/constants";
import type { ProjectSubtype } from "@/domain/project";
import type { CulturalActivity, CompanyType } from "@/domain/beneficiary";

export const ACTIVITIES: { value: CulturalActivity; labelKey: string }[] = [
  { value: "film", labelKey: "beneficiaries.film" },
  { value: "documentary", labelKey: "beneficiaries.documentary" },
  { value: "series", labelKey: "beneficiaries.series" },
  { value: "music_festival", labelKey: "beneficiaries.music_festival" },
  { value: "theatre", labelKey: "beneficiaries.theatre" },
  { value: "dance", labelKey: "beneficiaries.dance" },
  { value: "performing_arts", labelKey: "beneficiaries.performing_arts" },
  { value: "audiovisual_production", labelKey: "beneficiaries.audiovisual_production" },
];

export const COMPANY_TYPES: { value: CompanyType; labelKey: string }[] = [
  { value: "freelancer", labelKey: "beneficiaries.freelancer" },
  { value: "limited_company", labelKey: "beneficiaries.limited_company" },
  { value: "public_company", labelKey: "beneficiaries.public_company" },
  { value: "association", labelKey: "beneficiaries.association" },
  { value: "foundation", labelKey: "beneficiaries.foundation" },
  { value: "cooperative", labelKey: "beneficiaries.cooperative" },
  { value: "other", labelKey: "beneficiaries.other" },
];

export const INCENTIVE_TYPES = [
  {
    value: TaxIncentiveType.FILM_AUDIOVISUAL,
    labelKey: "promoters.wizard.incentive_film",
  },
  {
    value: TaxIncentiveType.PERFORMING_ARTS_MUSIC,
    labelKey: "promoters.wizard.incentive_performing_arts",
  },
];

export const getBeneficiaryActivityOptions = (t: TFunction) =>
  ACTIVITIES.map((option) => ({
    ...option,
    label: t(option.labelKey),
  }));
export const getBeneficiaryCompanyOptions = (t: TFunction) =>
  COMPANY_TYPES.map((option) => ({
    ...option,
    label: t(option.labelKey),
  }));
export const getBeneficiaryIncentiveOptions = (t: TFunction) =>
  INCENTIVE_TYPES.map((option) => ({
    ...option,
    label: t(option.labelKey),
  }));

export const POSITION_OPTIONS = [
  { value: "Administrador", labelKey: "beneficiaries.positions.administrator" },
  { value: "Consejero delegado", labelKey: "beneficiaries.positions.chief_executive" },
  { value: "Apoderado", labelKey: "beneficiaries.positions.authorized_representative" },
];

export const FILM_PRODUCTION_SUBTYPE_OPTIONS: { value: ProjectSubtype; labelKey: string }[] = [
  { value: "short_film", labelKey: "beneficiaries.short_film" },
  { value: "feature_film", labelKey: "beneficiaries.feature_film" },
  { value: "film", labelKey: "beneficiaries.film" },
  { value: "documentary", labelKey: "beneficiaries.documentary" },
  { value: "series", labelKey: "beneficiaries.series" },
];
